export default {
  None: 0,
  Ssl: 2,
  Tls: 3,
};
